'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/icons-place.html'),
        transclude: true,
        scope: {
            options: '=?myOptions',
            model: '=myModel',
        },
        controller: ['$scope', '$rootScope',
            function ($scope, $rootScope) {

                $scope.onChangeArea = (id) => {
                    const isCurrent = $scope.model ? $scope.model.id === id : false;
                    $scope.model = null;
                    if (!isCurrent) {
                        $scope.model = $scope.options.find(item => item.id === id);
                    }
                }
            }]
    };
}
